export default {"src":"/_next/static/media/costEfficient.4c199bb4.cf62339f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};